import Vue from 'vue'
import Vuex from 'vuex'
import { formatCategories, formatCommercialCategory, extractFilters, extractCommercialFilters, countAssetsByDistrict } from '@/lib/categoryHelper'
import axios from 'axios'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loaded: false,
    fsData: null,
    laData: null,
    comData: null,
    laCData: null,
    categories: null,
    filters: null,
    commercialFilters: null,
    districtSum: null,
    displayFilters: null,
    districtTable: null,
    commercialDataLoaded: false
  },
  getters: {
  },
  mutations: {
    setLoaded (state, loaded) {
      state.loaded = loaded
    },
    setCommercialDataLoaded (state, loaded) {
      state.commercialDataLoaded = loaded
    },
    setCategories (state, data) {
      state.categories = data
    },
    setCommercialCategories (state, data) {
      state.commercialCategories = data
    },
    setFsData (state, loaded) {
      state.fsData = loaded
    },
    setLaData (state, loaded) {
      state.laData = loaded
    },
    setComData (state, loaded) {
      state.comData = loaded
    },
    setLacData (state, loaded) {
      state.laCData = loaded
    },
    setFilters (state, categories) {
      console.log({ categories })
      state.filters = extractFilters(categories.filter(cat => cat.id !== 'commerces-de-vente-au-detail'))
      state.commercialFilters = extractCommercialFilters(categories.filter(cat => cat.id === 'commerces-de-vente-au-detail'))
    },
    setDistrictSum (state, loaded) {
      state.districtSum = loaded
    },
    setdistrictTable (state, loaded) {
      state.districtTable = loaded
    }
  },
  actions: {
    async loadMapData ({ state, commit }) {
      // communityData buckets needed here once the data will have districtID has a column
      const communityData = await axios.get('https://storage.googleapis.com/foodmap-dev/communityFeatures.json')
      const limAdmin = await axios.get('/static/limAdmin.json')
      const table = await axios.get('/static/limAdmin_siteId.json')
      const limAdminCentroids = await axios.get('/static/limAdminCentroids.json')
      const categoriesResponse = await axios.get('https://storage.googleapis.com/foodmap-dev/categories.json')
      const commercialCategorieResponse = await axios.get('https://storage.googleapis.com/foodmap-dev/commercialCategories.json')
      const categories = categoriesResponse.data
      const commercialCategory = commercialCategorieResponse.data
      // Extract categories from geojson to populate the filter
      formatCategories(categories)
      formatCommercialCategory(commercialCategory)
      // Adding a Commercial object in the categories

      commit('setCategories', [ ...categories, commercialCategory ])
      // commit('setCommercialCategories', commercialCategories)
      //
      const comGeojson = communityData.data
      const laGeojson = limAdmin.data
      const tmpLaCGeojson = limAdminCentroids.data
      // Adding a specific properties to the geojson named ... 'qty' ...
      // ... it reflects the number of assets in each district
      const laCGeojson = countAssetsByDistrict(comGeojson, tmpLaCGeojson)
      commit('setdistrictTable', table.data)
      commit('setLaData', laGeojson)
      commit('setComData', comGeojson)
      commit('setLacData', laCGeojson)
      commit('setLoaded', true)
    },
    async loadCommercialData ({ state, commit }) {
      const commercialData = await axios.get('https://storage.googleapis.com/foodmap-dev/commercialFeatures.json')
      const fsGeojson = commercialData.data
      commit('setFsData', fsGeojson)
      commit('setCommercialDataLoaded', true)
    }
  }
})
